module.exports = __webpack_public_path__ + "img/cattunnel07.22b2ae2d.jpg";